/* eslint-disable no-underscore-dangle */
import React from "react";
import moment from "moment-timezone";
import { find } from "lodash";
import {
  TaskCalendar,
  TaskEvent,
  CheckInStatus,
} from "components/TaskCalendar";
import {
  AppointmentLocation,
  CalendarEventFragment,
  PersonVisitType,
  AppointmentStatusType,
} from "types/globalTypes";
import { DATE_FORMAT } from "utils/date";
import { ENROLLMENT } from "containers/MemberProfile/constants";

const normalizeRenderCalendarView = (
  renderCalendarView: TaskCalendarEvent[],
  enrollmentDate: string,
): TaskEvent[] => {
  const normalizeCalendarView = renderCalendarView.map((task) => {
    const displayDateTime = task.checkInLocalTime
      ? `${moment(task.calendarDate).format("YYYY-MM-DD")} ${
          task.checkInLocalTime
        }`
      : `${moment(task.calendarDate).format("YYYY-MM-DD")} ${
          task.reminderTime
        }`;
    return {
      start: moment(displayDateTime)
        .subtract(4, "h")
        .toDate(),
      end: moment(displayDateTime)
        .subtract(4, "h")
        .toDate(),
      taskCategory: task.checkInCategory,
      photoUrl: task.photoUrl,
      taskIsValid: task.checkInIsValid,
      taskStatus: task.checkInStatus as CheckInStatus,
      taskId: task.reminderId,
      taskTime: task.reminderTime,
      isDemo: task.isDemo,
      calendarDate: moment(task.calendarDate, DATE_FORMAT).toDate(),
      taskDate: task.reminderDate,
      objectDetectionStatus: task.objectDetectionStatus,
      autoMedCount: task.autoMedCount,
    };
  });
  return [
    {
      start: moment(enrollmentDate).toDate(),
      end: moment(enrollmentDate).toDate(),
      taskCategory: ENROLLMENT,
      photoUrl: "",
      taskIsValid: true,
      taskStatus: ENROLLMENT,
      taskId: "enrollment",
      taskTime: "",
      isDemo: true,
      calendarDate: moment(enrollmentDate).toDate(),
      taskDate: "",
      objectDetectionStatus: "",
      autoMedCount: 0,
    },
    ...normalizeCalendarView,
  ];
};

export interface AppointmentType {
  __typename?: "Appointment";
  appointmentId: string;
  type: PersonVisitType;
  name?: string;
  dueTime?: Date;
  isAllDay?: boolean;
  lossAmount?: number;
  lossCurrencySymbol?: string;
  location?: AppointmentLocation;
  isMissed?: boolean;
  status?: AppointmentStatusType;
  allowCredit?: boolean;
}

interface CalendarContainerProps {
  enrollmentDate: string;
  primaryTimezone: string;
  renderCalendarView: TaskCalendarEvent[];
  routeCheckIn: (
    event: TaskCalendarEvent,
    memberTimezone: string,
    viewedDate: Date,
  ) => void;
  onNavigate?: (direction: string, date: Date) => void;
  initialDate?: Date;
  memberId: string;
}
export type TaskCalendarEvent = Partial<CalendarEventFragment>;

const TaskCalendarContainer: React.FC<CalendarContainerProps> = ({
  enrollmentDate,
  primaryTimezone,
  renderCalendarView,
  routeCheckIn,
  onNavigate,
  initialDate,
  memberId,
}: CalendarContainerProps) => (
  <TaskCalendar
    events={normalizeRenderCalendarView(renderCalendarView, enrollmentDate)}
    onNavigate={onNavigate}
    initialDate={initialDate}
    memberId={memberId}
    onHandleSelectEvent={({ taskDate, taskId, taskCategory }, viewedDate) => {
      if (taskCategory === ENROLLMENT) {
        return;
      }
      routeCheckIn(
        find(
          renderCalendarView,
          (task) =>
            moment(taskDate).format("YYYY-MM-DD") === task.reminderDate &&
            taskId === task.reminderId,
        ),
        primaryTimezone,
        viewedDate,
      );
    }}
  />
);

export default TaskCalendarContainer;
